import "./Splash.scss";

import React from "react";

const Splash = () => {
  return (
    <div className="splash">
      <div className="splash__spinner" />
    </div>
  );
};

export default Splash;
